import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

/**
 * Componente para gestionar preguntas frecuentes
 */
const SeccionPreguntas = ({
    preguntas,
    setPreguntas,
    dialogVisible,
    setDialogVisible,
    preguntaEdicion,
    setPreguntaEdicion,
    formPregunta,
    setFormPregunta
}) => {
    const agregarPregunta = () => {
        setPreguntaEdicion(null);
        setFormPregunta({ pregunta: '', respuesta: '' });
        setDialogVisible(true);
    };

    const editarPregunta = (index) => {
        setPreguntaEdicion(index);
        setFormPregunta(preguntas[index]);
        setDialogVisible(true);
    };

    const guardarPregunta = () => {
        if (preguntaEdicion !== null) {
            const nuevasPreguntas = [...preguntas];
            nuevasPreguntas[preguntaEdicion] = formPregunta;
            setPreguntas(nuevasPreguntas);
        } else {
            setPreguntas([...preguntas, formPregunta]);
        }
        setDialogVisible(false);
    };

    const eliminarPregunta = (index) => {
        setPreguntas(preguntas.filter((_, i) => i !== index));
    };

    return (
        <div style={{ padding: '1rem' }}>
            <Button
                label="Agregar Pregunta"
                icon="pi pi-plus"
                onClick={agregarPregunta}
                style={{ marginBottom: '1rem' }}
            />

            <DataTable value={preguntas} emptyMessage="No hay preguntas frecuentes">
                <Column field="pregunta" header="Pregunta" />
                <Column field="respuesta" header="Respuesta" />
                <Column
                    header="Acciones"
                    body={(rowData, options) => (
                        <div style={{ display: 'flex', gap: '0.25rem' }}>
                            <Button
                                icon="pi pi-pencil"
                                rounded
                                text
                                severity="warning"
                                onClick={() => editarPregunta(options.rowIndex)}
                            />
                            <Button
                                icon="pi pi-trash"
                                rounded
                                text
                                severity="danger"
                                onClick={() => eliminarPregunta(options.rowIndex)}
                            />
                        </div>
                    )}
                    style={{ width: '120px' }}
                />
            </DataTable>

            {/* Dialog para agregar/editar pregunta */}
            <Dialog
                visible={dialogVisible}
                style={{ width: '600px' }}
                header={preguntaEdicion !== null ? 'Editar Pregunta' : 'Nueva Pregunta'}
                modal
                onHide={() => setDialogVisible(false)}
                footer={
                    <div>
                        <Button
                            label="Cancelar"
                            icon="pi pi-times"
                            onClick={() => setDialogVisible(false)}
                            className="p-button-text"
                        />
                        <Button
                            label="Guardar"
                            icon="pi pi-check"
                            onClick={guardarPregunta}
                        />
                    </div>
                }
            >
                <div style={{ padding: '1rem' }}>
                    <div className="field" style={{ marginBottom: '1rem' }}>
                        <label htmlFor="pregunta">Pregunta</label>
                        <InputText
                            id="pregunta"
                            value={formPregunta.pregunta}
                            onChange={(e) => setFormPregunta({ ...formPregunta, pregunta: e.target.value })}
                            style={{ width: '100%', marginTop: '0.5rem' }}
                        />
                    </div>
                    <div className="field">
                        <label htmlFor="respuesta">Respuesta</label>
                        <InputTextarea
                            id="respuesta"
                            value={formPregunta.respuesta}
                            onChange={(e) => setFormPregunta({ ...formPregunta, respuesta: e.target.value })}
                            rows={4}
                            style={{ width: '100%', marginTop: '0.5rem' }}
                        />
                    </div>
                </div>
            </Dialog>
        </div>
    );
};

export default SeccionPreguntas;
